import styled from 'styled-components';

import { Media } from '../../assets/Mixins.style';

export const Wrapper = styled.header`
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-shrink: 0;
  width: 100%;
  height: 88px;
  padding: 15px 60px;
  background: ${(props) => props.theme.background};

  &:after {
    position: absolute;
    width: auto;
    height: 2px;
    background: ${(props) => props.theme.backgroundLine};
    right: 40px;
    left: 40px;
    bottom: 0;
    z-index: +1;
    content: '';

    ${Media.lg`
      display: none;
    `}
  }

  ${Media.xlg`
    padding: 0 45px;
  `}

  ${Media.lg`
    height: 80px;
    padding: 0 20px;
    border-bottom: 1px solid ${(props) => props.theme.backgroundLine};
  `}
`;

export const Box = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const Titlebox = styled.div`
  display: flex;
  width: 100%;
  align-items: center;

  ${Media.lg`
    flex-wrap: wrap;
  `}
`;

export const Title = styled.h1`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 28px;
  font-weight: 700;
  cursor: default;

  ${Media.lg`
    font-size: 22px;
  `}
`;

export const Grow = styled.div`
  flex-grow: 1;
`;

export const Profilebox = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
